module.exports = __webpack_public_path__ + "img/image_512x512.1f59e2d1.png";